import { EntitySwitch } from '@backstage/plugin-catalog';
import { EntitySonarQubeCard } from '@backstage-community/plugin-sonarqube';
import { isSonarQubeAvailable } from '@backstage-community/plugin-sonarqube-react';
import { Grid } from '@material-ui/core';

export const sonarContent = (
  <EntitySwitch>
    <EntitySwitch.Case if={isSonarQubeAvailable}>
        <Grid item md={6}>
            <EntitySonarQubeCard variant="gridItem" />
        </Grid>
    </EntitySwitch.Case>
  </EntitySwitch>
);
